import { render, staticRenderFns } from "./rand-diamond.vue?vue&type=template&id=4c66eec2&"
import script from "./rand-diamond.vue?vue&type=script&lang=js&"
export * from "./rand-diamond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports